import React from 'react'
import PropTypes from 'prop-types'

import Footer from './components/footer'

import * as styles from './styles'

const LayoutComponent = ({ children }) => (
  <div css={styles.container}>
    <div css={styles.contentContainer}>
      <div id="main-content" css={styles.content}>
        {children}
      </div>
    </div>
    <Footer />
  </div>
)

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutComponent
